import React from "react";
import { FaBullseye, FaHandshake, FaUsers } from "react-icons/fa";
import "./MvtSection.css";

const MvtSection = () => {
    return (
        <section className="_mvtSec_v1A_">
            <div className="_sC_w2B_">
                <h1 className="_hTitle_s5E_" style={{ textAlign: "center", paddingBottom: "1rem", marginBottom: "2rem" }}>
                    Our Commitments
                </h1>
                <div className="_mvtGrid_x3C_">

                    {/* Mission */}
                    <div className="_mvtCard_y4D_ mission-card feature-item">
                        <div className="feature-icon">
                            <FaBullseye />
                        </div>
                        <h3 className="feature-title-text">Our Mission</h3>
                        <p className="_cText_c8H_">
                            To make pure, mindful living easy and accessible—empowering customers and local sellers with a trustworthy, transparent marketplace for Satvik groceries, organic foods, pooja essentials, and spiritual books.
                        </p>
                    </div>

                    {/* Values */}
                    <div className="_mvtCard_y4D_ values-card feature-item">
                        <div className="feature-icon">
                            <FaHandshake />
                        </div>
                        <h3 className="feature-title-text">Our Values</h3>
                        <ul className="_cList_d9I_">
                            <li>Ethics and transparency in every transaction</li>
                            <li>Honoring tradition with modern convenience</li>
                            <li>Championing local and authentic businesses</li>
                            <li>Building trust through quality and service</li>
                        </ul>
                    </div>

                    {/* Team */}
                    <div className="_mvtCard_y4D_ team-card feature-item">
                        <div className="feature-icon">
                            <FaUsers />
                        </div>
                        <h3 className="feature-title-text">Meet the Team</h3>
                        <p className="_cText_c8H_">
                            We’re a passionate team of technologists, designers, and product experts, committed to making Satvik and conscious shopping simple for you. Your trust and feedback shape everything we build.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MvtSection;